import React, { useState } from 'react';
import {
  useEditorState,
  getMarks,
  setMarks,
  focusEditor,
  useEventPlateId,
} from '@udecode/plate-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ColorPicker from 'components/ColorPicker';
import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';

import './table-dropdown.scss';

const ColorDropdown = ({ id, colorPickerProps, ...props }) => {
  const { savedColors, usedColors, saveColor, deleteColor } = colorPickerProps || {};
  const editor = useEditorState(useEventPlateId(id));
  const marks = getMarks(editor);
  const { color } = marks || {};

  const [open, setOpen] = useState(false);

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const trigger = (
    <ToolbarDropdownButton
      className="plate-toolbar__button toolbar-dropdown-button"
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'font']} />
    </ToolbarDropdownButton>
  );

  const handleColorSelect = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setMarks(editor, { color: value });
    dismiss();
    // To prevent errors from race conditions of the DOM node not being ready
    setTimeout(() => focusEditor(editor), 0);
  };

  const handleHexChange = (value) => {
    setMarks(editor, { color: value });
    // To prevent errors from race conditions of the DOM node not being ready
    setTimeout(() => focusEditor(editor), 0);
  };

  const handleColorSave = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (saveColor) saveColor(value);
  };

  const handleSavedColorDelete = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (deleteColor) deleteColor(value);
  };

  return (
    <ToolbarDropdown
      isOpen={open}
      show={show}
      dismiss={dismiss}
      DropdownButton={trigger}
      name="color-dropdown"
      tooltipName="Change color"
      className="plate-toolbar__dropdown-button color-picker-dropdown"
      root={null}
    >
      <ColorPicker
        color={color}
        savedColors={savedColors}
        usedColors={usedColors}
        handleColorSelect={handleColorSelect}
        handleColorSave={handleColorSave}
        handleHexChange={handleHexChange}
        handleSavedColorDelete={handleSavedColorDelete}
        hasClearOption
      />
    </ToolbarDropdown>
  );
};

export default ColorDropdown;
